import { Outlet } from 'react-router';
import Header from '#client/components/layout/Header/Header';
import Footer from '#client/components/layout/Footer/Footer';
import './MainLayout.css';

const MainLayout = () => {
    return (
        <div className="app-container">
            <Header />
            <main className="main-content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default MainLayout;
